export default "__VITE_ASSET__CgDll1XC__"